import React, { useState, useEffect } from "react";
import { Select, Checkbox } from "antd";
import { useIntl } from "react-intl";
import { listSettingsData } from "../../api/server";
import { SettingsDataSelect } from "../../components/forms/AutoCompleteComponent";
const { Option } = Select;
const ProviderTariffSelector = (props) => {
  const { onSelectProviderTariff, activeEvent, readonly, fromEmployee } = props;
  const intl = useIntl();
  const [items, setItems] = useState([]);
  const [useDefault, setUseDefault] = useState();

  useEffect(() => {
    const filter = {
      $and: [
        {
          $or: activeEvent.client_tariff_id
            ? [{ active: true }, { id: activeEvent.client_tariff_id }]
            : [{ active: true }],
        },
      ],
    };

    const params = { name: "client_tariffs", filter };
    listSettingsData(params).then(({ error, data }) => {
      if (data) {
        setItems(data.items);
      }
    });
  }, []);

  useEffect(() => {
    if (activeEvent && useDefault !== false) {
      setUseDefault(!activeEvent.client_tariff_id);
    }
  }, [activeEvent, useDefault]);

  const onDefaultTariffChange = (e) => {
    if (e.target.checked) {
      onSelectProviderTariff(null);
    }
    setUseDefault(e.target.checked);
  };

  const getOptionLabel = (option) => {
    return `${option.name} (${option.cost})`;
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Checkbox
        onChange={onDefaultTariffChange}
        checked={useDefault}
        disabled={readonly || fromEmployee}
      >
        {intl.formatMessage({
          id: "app.scheduling.defaultTariff",
        })}
      </Checkbox>
      <div style={{ height: "10px" }} />
      {useDefault ? null : (
        <SettingsDataSelect
          disabled={readonly || fromEmployee}
          placeholder={intl.formatMessage({
            id: "app.scheduling.providerTariff",
          })}
          onChange={onSelectProviderTariff}
          settingsdataName={"client_tariffs"}
          type="list"
          defaultValue={activeEvent ? activeEvent.client_tariff_id : null}
          getOptionLabel={getOptionLabel}
        />
      )}
    </div>
  );
};

export default ProviderTariffSelector;
